import { render } from "./ProductEnPhone.vue?vue&type=template&id=d3fc51f2&scoped=true"
import script from "./ProductEnPhone.vue?vue&type=script&lang=js"
export * from "./ProductEnPhone.vue?vue&type=script&lang=js"

import "./ProductEnPhone.vue?vue&type=style&index=0&id=d3fc51f2&scoped=true&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3fc51f2"]])

export default __exports__